import React, { useCallback, useState } from 'react';
import useEpisodes from '../../common/hooks/useEpisodes';
import useSharedShowPageContext from '../../common/hooks/useSharedShowPageContext';
import { size } from '@/helpers/lodash';
import FilterMenu from '@/components/app/FilterMenu';
import Selector from '@/components/app/Selector';
import Text, { FONT_SIZE_090 } from '@/components/component-library/Text';

const EpisodesHeader = () => {
  const { isLoading: episodesLoading } = useEpisodes();
  const {
    currentSeasonNumber,
    seasonOptions,
    onChangeSeason,
    haveSetSeasonFromUrl
  } = useSharedShowPageContext();

  // Track if the seasons overlay is open
  const [seasonsOpen, setSeasonsOpen] = useState(false);

  // When the user clicks on a season, mark the seasons overlay as closed
  // and call the handler
  const handleClickSeason = useCallback(({ id }) => {
    setSeasonsOpen(false);

    if (onChangeSeason) {
      onChangeSeason(id);
    }
  }, [onChangeSeason]);

  // Compute the current season text (ie "Season 1") to display in the drop down selector
  const seasonSelectorValue = (currentSeasonNumber && size(seasonOptions))
    ? (seasonOptions.find(
        (s) => s.id.toString() === currentSeasonNumber.toString()
      ) || {}).value || ''
    : 'Season 1';

  return (
    (!episodesLoading || !haveSetSeasonFromUrl) && (
      <>
        <Text bold fixed size={FONT_SIZE_090} useHeaderFont>
          Episodes Title
        </Text>
        <div className='season-selector-mobile'>
          {size(seasonOptions) > 1 ? (
            <>
              <Selector
                className='channel-seasons-selector-mobile'
                disabled={size(seasonOptions) < 2}
                onClick={() => setSeasonsOpen(true)}
                value={seasonSelectorValue}
              />
              <FilterMenu
                filterOptions={seasonOptions}
                isOpen={seasonsOpen}
                onClickFilter={handleClickSeason}
                onClose={() => setSeasonsOpen(false)}
                selectedFilterId={currentSeasonNumber}
              />
            </>
          ) : (
            <Text bold fixed useHeaderFont>
              {seasonSelectorValue}
            </Text>
          )}
        </div>
      </>
    )
  );
};

export default EpisodesHeader;
